// 组件对象，大写
import crudQuerys from './crudQuerys.vue'
export default crudQuerys
